import styled from "styled-components";

export const H1 = styled.h1`
  font-size: 48px;
  line-height: 1em;
  margin-bottom: 16px;
`;

export const H2 = styled.h2`
  font-size: 28px;
  font-weight: 700;
`;

export const H3 = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: black;
  transition: 0.2s;

  a {
    border-bottom: none;
    //color: black;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const P = styled.p`
  margin: 8px 0;
  padding-bottom: 8px;
  font-size: 16px;
  line-height: 1.5em;
  color: #393f45;
`;

export const TextWrapper = styled.div`
  margin: 8px 0 32px;

  font-size: 16px;
  line-height: 1.5em;
  color: #393f45;

  p {
    margin-bottom: 1em;
  }
`;

export const Button = styled.a`
  background: linear-gradient(to bottom, #fed96f, #fec41f);

  color: #252628;
  //padding: 14px 41px;
  font-size: 16px;
  font-weight: 700;
  border: 0;
  border-radius: 12px;
  transition: 0.2s;
  position: relative;
  width: 150px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
    left: 0;
    top: 0;
    background: linear-gradient(to bottom, #f7bf68, #f39c13);
    opacity: 0;
    transition: 0.2s;
    border-radius: 12px;
  }

  &:hover:before {
    opacity: 1;
  }

  &:active {
    opacity: 0.8;
  }
  span {
    z-index: 1;
    position: relative;
  }
`;

export const ButtonContainer = styled.div`
  text-align: center;
`;

export const VacancyButton = styled(ButtonContainer)`
  margin-bottom: 20px;
`;
